import { Box, Divider, Grid, Stack } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';

import useStyles from './styles';

const GridArtworkInfo = ({ artwork, certificate }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { title, size, medium, year_created, period_created, total_edition } = artwork || {};
  const { edition_number } = certificate || {};
  const { legal_name } = certificate?.issued_by || {};

  const textEdition = (edition, total_edition) => {
    if (!edition) {
      return '--';
    }
    if (total_edition === 1) {
      return t('unique');
    }
    return `${edition}/${total_edition}`;
  };

  return (
    <Box className={classes.wrapper}>
      <Grid container>
        <Grid
          item
          xs={8}
        >
          <Stack
            direction="row"
            spacing={4}
          >
            <div className={classes.wrapText}>
              <Text className={classes.textInfoArtwork}>{`${t('title_of_artwork')}:`}</Text>
              <Text className={classes.textInfoArtwork}>{`${t('size')}:`}</Text>
              <Text className={classes.textInfoArtwork}>{`${t('medium')}:`}</Text>
              <Text className={classes.textInfoArtwork}>{`${t('year_completed')}:`}</Text>
              <Text className={classes.textInfoArtwork}>{`${t('text_certificate_edition')}:`}</Text>
            </div>

            <div>
              <Text
                fontWeightBold
                className={clsx(classes.textInfoArtwork, classes.textBold)}
              >
                {title || '--'}
              </Text>
              <Text className={classes.textInfoArtwork}>
                {size?.height && size?.width
                  ? size?.depth
                    ? `${size?.height} cm x ${size?.width} cm x ${size?.depth} cm`
                    : `${size?.height} cm x ${size?.width} cm`
                  : '--'}
              </Text>
              <Text className={classes.textInfoArtwork}>{medium?.name || '--'}</Text>
              <Text className={classes.textInfoArtwork}>
                {year_created || period_created || '--'}
              </Text>
              <Text className={clsx(classes.textInfoArtwork, classes.textBold)}>
                {textEdition(edition_number, total_edition)}
              </Text>
            </div>
          </Stack>
        </Grid>

        <Grid
          item
          xs={4}
        >
          <Text className={classes.textInfoArtwork}>{`${t('artist_signature')}:`}</Text>

          <Divider className={classes.divier} />

          <Text
            mt={8}
            type="sm"
            fontWeightBold
            className={classes.letterSpacing}
          >
            {legal_name}
          </Text>

          <Stack direction="row">
            <Text
              type="xs"
              className={classes.textWidth}
            >
              {t('artist')}
            </Text>

            <Stack
              direction="row"
              sx={{ flex: 1 }}
            >
              <Text
                type="xs"
                className={classes.textDate}
              >
                {t('date')}
              </Text>

              <div className={classes.line}></div>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GridArtworkInfo;
